import React from 'react';
import { bonuses, type Bonus } from '../data/bonuses';
function BonusCover({
  bonus
}: {
  bonus: Bonus;
}) {
  if (bonus.cover) {
    return <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-[5/4] w-full border-b border-rink-line object-cover object-center" data-id="element-23" data-mp="pj6cm4pkakr0" />;
  }
  return <div aria-hidden="true" className="relative flex h-[230px] items-center justify-center border-b border-rink-line bg-glacier-soft sm:h-[265px]" data-id="element-24" data-mp="1u5b71f5c9v8">
      <div className="relative w-[66%] max-w-[280px] aspect-[16/10] overflow-hidden rounded-card bg-ice shadow-cover ring-1 ring-black/5" data-id="element-25" data-mp="3o1ldun9phdhc">
        <div className="h-[9%] bg-lilac" data-id="element-26" data-mp="3t1r9sfn0dm58" />
        <div className="px-[8%] pt-[7%]" data-id="element-27" data-mp="3t2sn6qrhykq4">
          <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-amber-deep" data-id="element-28" data-mp="1m9qf188jt3gj">
            Bonus {bonus.number}
          </span>
          <span className="mt-1.5 block font-display text-[15px] font-bold leading-tight text-rink sm:text-base" data-id="element-29" data-mp="1r78rh8lry0ta">
            {bonus.title}
          </span>
        </div>
        <svg viewBox="0 0 100 20" preserveAspectRatio="none" className="absolute left-[8%] bottom-[24%] h-[10%] w-[84%]" data-id="element-30" data-mp="3dek4p7xnslmv">
          <path d="M0 14 C 20 2, 35 2, 50 10 S 80 18, 100 6" fill="none" stroke="#9CC9E3" strokeWidth="2" vectorEffect="non-scaling-stroke" data-id="element-31" data-mp="3n5eng2bp533k" />
        </svg>
        <span className="absolute bottom-[9%] left-[8%] font-display text-[10px] font-semibold text-ink-soft" data-id="element-32" data-mp="2uhivtc0zi1dn">
          Figure Skating Class Ready
        </span>
        <span className={`absolute inset-x-0 bottom-0 h-[5%] ${bonus.accent}`} data-id="element-33" data-mp="33h5qzg34eay9" />
      </div>
    </div>;
}
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-rink" data-id="element-34" data-mp="noq5uuwu9mz7">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-35" data-mp="irpzsjzzok83">
        <div className="text-center" data-id="element-36" data-mp="itazeo15utct">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-amber" data-id="element-37" data-mp="3cjpsvc949iuf">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-38" data-mp="3hk3yyor5qipt">
            Five instant-use <span className="text-amber" data-id="element-39" data-mp="3qhmljxkg953t">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-40" data-mp="2tsoq0d4vl35l">
            The volumes give you the season. These five fit it to your club,
            your rink and your skaters this week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-41" data-mp="32s227dkdw5u0">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-card border border-rink-line bg-rink-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-42" data-mp="37kv6y1fure63" data-mpi={i}>
              <BonusCover bonus={bonus} data-id="element-43" data-mp="27j89h0btb7v5" />
              <div className="px-5 pb-6 pt-4" data-id="element-44" data-mp="22l6izuc2469n">
                <div className="flex flex-wrap items-center gap-2" data-id="element-45" data-mp="22lg71cdjk3cp">
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-46" data-mp="1xl29io9kgbsx">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-amber px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-amber-ink" data-id="element-47" data-mp="1ol5fs88bkmr0">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl font-bold leading-snug text-white" data-id="element-48" data-mp="1euswskg5l1mz">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-49" data-mp="19y2ia1jzye3o">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}